function isReactSnapRuntime() {
  return typeof navigator !== "undefined" && /ReactSnap/i.test(String(navigator.userAgent || ""));
}

export function initYandexMetrika(counterId) {
  if (typeof window === "undefined") return;
  if (!counterId) return;

  // react-snap / prerender: не грузим внешние скрипты на этапе сборки
  if (window.__REACT_SNAP__ || isReactSnapRuntime()) return;

  // Prevent double init
  if (window.__ym_inited) return;
  window.__ym_inited = true;

  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
    m[i].l = 1 * new Date();
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    k.onload = () => { window.__ym_loaded = true; };
    k.onerror = () => { window.__ym_loaded = false; console.warn("[ym] failed to load tag.js"); };
    a.parentNode.insertBefore(k, a);
    window.__ym_script_attached = true;
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

  window.ym(counterId, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });
}
